export function determineNavigationSettings(node) {

  const defaultSettings = { hamburger: { enabled: false, position: 'left' } };

  if (node.properties === void 0) {
    return defaultSettings;
  }

  if (node.properties.navigationSettings === void 0) {
    return defaultSettings;
  }

  return structuredClone(node.properties.navigationSettings);

}